import { render } from "./App.vue?vue&type=template&id=1748e1bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1748e1bc&lang=css"

import exportComponent from "D:\\mywork\\codes\\iiot-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__